import { EditOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button, Tag } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

import ProgrammeCommercialService from "../../../api/programme.commercial.service";
import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH, GREEN_TAG, RED_TAG } from '../../../utility/Constants';
import ProgrammComercialEntry from './ProgrammComercialEntry';
import { useDispatch,useSelector } from 'react-redux';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import CustomTableSearch from "../../common/CustomTableSearch";







const ProgrammCommercialList = () => {
  const state = useSelector((state)=>state.programmeCommercial)
  const [visible, setVisible] = useState(false);
  const [filteredSearchList, setFilteredSearchList] = useState([]);


  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);
  const pageSizeOptions = ['10', '20', '30', '50' , '100'];

  const [programmecomponentList, setProgrammecomponentList] = useState([]);
  const [programmcommercialData, setProgrammcommercialData] = useState({
    component_id : '',
    description: '',
    programme_id:'',
    group_id: '',
    programme_name:'',
    account_name: '',
    account_id: '',
    amount: "",
    is_gst_applicable: 'N',
    is_reg_component: '',
    component_type: '',
    cgst_id:'',
    sgst_id:'',
    hsn_code:'',
    is_security:'N',
    mode: ADD_MODE,
    is_active:"Y",
    for_month:'',
    rate_for:'MEMBER'

});

  const showDrawer = (rowdata) => {
  
 //   setProgrammeCommercialData(_);

    console.log('rowdata',rowdata);
    

 setProgrammcommercialData({
      component_id : rowdata.component_id,
      description: rowdata.description,
      programme_id:rowdata.programme_id,
      group_id: rowdata.group_id,
      programme_name:rowdata.programme_name,
      account_name: rowdata.account_name,
      account_id: rowdata.account_id,
      amount : rowdata.amount,
      is_gst_applicable: rowdata.is_gst_applicable,
      is_reg_component: rowdata.is_reg_component,
      component_type: rowdata.component_type,
      cgst_id: rowdata.cgst_id,
      sgst_id: rowdata.sgst_id,
      hsn_code:rowdata.hsn_code,
      is_security:rowdata.is_security,
      mode: "EDIT",
      is_active:rowdata.is_active,
      for_month:rowdata.for_month,
      rate_for:rowdata.rate_for
  })

    setVisible(true);

  };


  const onClose = () => {
    setVisible(false);
  };


  


  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },

    {
      title: 'Action',
      key: 'action',
      
      render: (selectedObj) => (
        
        <Space size="middle">
          {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}
          <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
        </Space>
      ),
    },
    
    {
      title: 'Rate For',
      dataIndex: 'rate_for',
      key: 'rate_for',
      sorter: (a, b) => a.rate_for.localeCompare(b.rate_for),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      sorter: (a, b) => a.description.localeCompare(b.description),
    },
    {
      title: 'Type',
      dataIndex: 'component_type',
      key: 'component_type',
      sorter: (a, b) => a.component_type.localeCompare(b.component_type),
    },
    {
      title: 'Programme',
      dataIndex: 'short_code',
      key: 'short_code',
      // sorter: (a, b) => (a.short_code !=null && b.short_code != null) ? a.short_code.localeCompare(b.short_code) : '',
      sorter: (a, b) => (a.short_code || "").localeCompare(b.short_code || ""),
    },
    {
      title: 'Group',
      dataIndex: 'programme_group',
      key: 'programme_group',
      sorter: (a, b) => (a.programme_group || "").localeCompare(b.programme_group || ""),
    },
    {
      title: 'Account Name',
      dataIndex: 'account_name',
      key: 'account_name',
      sorter: (a, b) => a.account_name.localeCompare(b.account_name),
    },
    {
      title: 'HSN',
      dataIndex: 'hsn_code',
      key: 'hsn_code',
      sorter: (a, b) => a.hsn_code - b.hsn_code,
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align:'right',
      render: (selectedObj,record) => (
        <Space size="middle">
          {/* {record.amount.toFixed(2)} */}
          {record.amount}
        </Space>
      )
    },
    {
      title: 'Security Dep.',
      dataIndex: 'is_security',
      key: 'is_security',
      render: (selectedObj,record) => (
        <Space size="middle">
          {
            record.is_security == "Y" ? <><Tag>Yes</Tag></> : <><Tag>No</Tag></>
          }
        </Space>
      )
    },
    {
      title: 'GST',
      dataIndex: 'is_gst_applicable',
      key: 'is_gst_applicable',
      render: (selectedObj,record) => (
        <Space size="middle">
          {
            record.is_gst_applicable == "Y" ? <><Tag color={GREEN_TAG}>Yes</Tag></> : <><Tag color={RED_TAG}>No</Tag></>
          }
        </Space>
      )
    },
    {
      title: 'GST Rate',
      dataIndex: 'cgst_rate',
      key: 'cgst_rate',
      render: (selectedObj,record) => (
        <Space style={{display:'flex',flexDirection:'column'}}>
          {record.cgst_rate != "" ? <><Tag color="#229bca">{record.cgst_rate}</Tag></> : <></>}
          {record.sgst_rate != "" ? <><Tag color="#229bca">{record.sgst_rate}</Tag></> : <></>}
        </Space>
      )
    },
    {
      title: 'Active',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (selectedObj,record) => (
        <Space size="middle">
          {
            record.is_active == "Y" ? <><Tag color={GREEN_TAG}>Active</Tag></> : <><Tag color={RED_TAG}>Not Active</Tag></>
          }
        </Space>
      )
    },

    
  
    
  ];


  useEffect(() => {
    ProgrammeCommercialService.list().then((res) => {
      // console.log(res.data.response_data);
      setProgrammecomponentList(res.data.response_data);
      setFilteredSearchList(res.data.response_data);
    });
  }, [state.programmeCommercial])

  const onSearch = (e) => {
     
    setFilteredSearchList([]);
    const string = e.target.value;
    const filtered_list = programmecomponentList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
    setFilteredSearchList(filtered_list)
  }

  return (
    <>
      <CustomTableSearch onSearchTable={onSearch} />
      <Table 
      columns={columns} 
      rowKey='component_id' 
      //dataSource={programmecomponentList}
      dataSource={filteredSearchList}  
      pagination={{
        pageSizeOptions: pageSizeOptions,
        showSizeChanger: true,
        defaultPageSize: parseInt(pageSizeOptions[0], 10), // Set the initial page length
        showTotal,
        onChange(current) {
          setPage(current);
        }
      }}
      size="small"
     
      />

      <Drawer
          title="Edit programme commercial"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose = {true}
          closeIcon = {<><DrawableCloseIcon /></>}
        >
          <ProgrammComercialEntry data={programmcommercialData}  onDrawerClose={onClose} />
        </Drawer>

    </>
  );
};

export default ProgrammCommercialList;